<template>
  <div class="h-screen w-full">
    <router-view />
    <Toaster />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Toaster from "@/components/ui/Toaster.vue";

export default defineComponent({
  name: "App",
  components: {
    Toaster,
  },
});
</script>

<style>
/* Base styles are handled by Tailwind in index.css */
</style>
